<template>
    <div class="client-status-table">
        <div class="alert alert-danger text-center font-bold" v-if="columns > 12">{{ t_broken }}</div>
        <div class="header">
            <div class="row client-status-header-row" v-if="table_head.length > 0">
                <div v-for="header in table_head"
                     @click.stop.prevent="sort(header['id'])"
                     :class="[sort_column === header['id'] ? sort_direction : '', `cursor-pointer col-md-${col}`]"
                >
                    <strong>{{ header['title'] }}</strong>

                    <span v-if="sort_column === header['id'] && sort_direction === 'asc'" class="sort-asc"></span>
                    <span v-else-if="sort_column === header['id'] && sort_direction  === 'desc'" class="sort-desc"></span>
                    <span v-else class="sort-alt"></span>
                </div>
            </div>
        </div>
        <div class="body client-status-body">
            <div class="row cs-row text-center text-danger" v-if="table_head.length === 0">
                <div class="no-margins p-sm">{{ t_no_result_head }}</div>
            </div>
            <div class="row cs-row text-center text-danger" v-else-if="table_data.length === 0 && table_head.length > 0">
                <div class="no-margins p-sm">{{ t_no_result_data }}</div>
            </div>
            <div class="row client-status-row" v-else v-for="row in table_data">
                <div :class="'client-status-col col-md-'+col" v-for="header in table_head" v-html="row[header['id']]['data'] || '-'"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import debounce from 'debounce';
    import toaster from "../../common/toaster";

    export default {
        props: [
            'location_id',
            'search',
            'groups',
            'locations'
        ],
        data() {
            return {
                t_load_error: Lang.langGet("Failed to load table."),
                t_no_result_head: Lang.langGet("Select or create a Column Preset to show data."),
                t_no_result_data: Lang.langGet("No results with current filter."),
                t_broken: Lang.langGet("WARNING! You have selected more than 12 columns. This is NOT recommended because the rows look broken now!"),
                table_head: [],
                table_data: [],
                columns: 1,
                sort_column: '',
                sort_direction: '',
                filter_id: -1,
                preset_id: -1
            }
        },
        methods: {
            load: debounce(function () {
                axios.post('/system/client-status/table', {
                    project_id: Laravel.activeProject,
                    filter_id: this.filter_id,
                    preset_id: this.preset_id,
                    location_id: this.location_id,
                    search:    this.search,
                    groups:    this.groups,
                    locations: this.locations
                }).then((response) => {
                    this.table_head = response.data.data.header;
                    this.table_data = response.data.data.data;
                    this.columns = response.data.data.columns;

                    this.$nextTick(() => {
                        $(this.$el).find('[data-featherlight="image"]').featherlight();

                        let imageList = $(this.$el).find('[data-featherlight="image"]');
                        $.each(imageList, function (index, value) {
                            value.children[0]?.setAttribute('aria-label', 'image preview');
                        });
                    });
                }).catch((error) => {
                    if (error.response.status === 401) {
                        window.location = '/login';
                    }

                    toaster.error(this.t_load_error);
                });
            }, 500),
            sort: function (column) {
                if (this.sort_column === column) {
                    if (this.sort_direction === 'asc') {
                        this.sort_direction = 'desc';
                    } else {
                        this.sort_direction = 'asc';
                    }
                } else {
                    this.sort_column = column;
                    this.sort_direction = 'asc';
                }

                let ascDesc = this.sort_direction === 'asc' ? 1 : -1;
                this.table_data.sort(function (a, b) {
                    const sortConfig = {
                        numeric: true,
                        sensitivity: 'base',
                        ignorePunctuation: true
                    };

                    const aElement = (a[column].sort || a[column].data || '').toString();
                    const bElement = (b[column].sort || b[column].data || '').toString();

                    return ascDesc * aElement.localeCompare(bElement, Laravel.activeLanguage, sortConfig);
                });
            },
            reset: function () {
                _.extend(this.$data, this.$options.data());
            }
        },
        computed: {
            col: function () {
                let calculatedColumns = Math.floor(12 / parseInt(this.columns));

                if (calculatedColumns < 1) {
                    calculatedColumns = 1;
                }
                return calculatedColumns;
            },
            sorted: function () {
                if (this.sort_column && this.sort_direction) {
                    return this.sort_column + '|' + this.sort_direction;
                }

                return '';
            }
        },
        mounted() {
            if(this.location_id !== undefined && this.location_id !== '') {
                var newLocations = this.locations;
                newLocations.push(this.location_id);
                this.$emit('update:locations', newLocations);
            }
            EaseEventBus.listen('updateTable', (data) => {
                if (data == null) {
                    this.reset();
                } else {
                    this.filter_id = data.filter;
                    this.preset_id = data.preset;
                    this.load();
                }
            });
        }
    }
</script>

<style scoped>
    .sort-asc:after {
        font-family: "Font Awesome 6 Pro" !important;
        content: '\f161' !important;
        opacity: 0.6 !important;
    }
    .sort-desc:after {
        font-family: "Font Awesome 6 Pro" !important;
        content: '\f160' !important;
        opacity: 0.6 !important;
    }
    .sort-alt:after {
        font-family: "Font Awesome 6 Pro" !important;
        content: '\e099' !important;
        opacity: 0.125 !important;
    }
    .client-status-row {
        margin: 0;
    }
    .client-status-header-row {
        margin: 0;
        border-bottom: 1px solid rgba(0, 0, 0, 0.38);
    }
    .client-status-row:nth-child(odd) {
        background-color: #e8e8e8;
    }
    .client-status-col {
        margin-top: auto;
        margin-bottom: auto;
    }
</style>
